import request from '@/utils/request'

export function getEpms5000(param) {
  let data = param
  return request({
    url: `/delivery/epms5000/getEpms5000`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}